module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "الفصل-الأول"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "فن-الإتيكيت-واللباقة-والأناقة"
    }
  }, [_c('h2', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فنُّ (الإتيكيت) واللَّباقة، والأناقة")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.33333in",
      "height": "1.77083in"
    },
    attrs: {
      "alt": "",
      "src": "media/file3.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("(الإتيكيت) هو وسيلةٌ أو أداةٌ يستَخدِمُها النِّساءُ الواثِقاتُ للتَّغلُّبِ على تعقيدات التَّفاعلاتِ الاجتماعيَّةِ، والتَّأثيرِ بشكلٍ إيجابيٍّ على العالمِ من حولِهِنَّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كلمة (إتيكيت) هي كلمةٌ مستعارةٌ من اللُّغةِ الفرنسيَّةِ، وتعني (ملصق) أو (علامة)، وقد تمَّ طرحُها لأوَّلِ مرَّةٍ في المجتمعِ من قِبَلِ الملك لويس الرَّابع عشر، المُلقَّبِ باسم: ملكِ الشَّمس، في القرن السَّابع عشر كوسيلةٍ للتَّحكُّمِ في سلوكِ حاشيَتِه، إلَّا أنَّ مفهومَ (الإتيكيت) أصبحَ الآن أكثرَ انتشارًا ممَّا كان في الماضي، حيثُ لا يزالُ وثيقَ الصِّلةِ بحياتنا اليوميَّةِ، وضروريًّا في المجتمع الحديث.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت الآدابُ حاضِرةً عبرَ التَّاريخ، حتَّى أنَّ السُّلوكَ الاجتماعيَّ ظهرَ لأوَّلِ مرَّةٍ في مصر، حوالي 2400 قبلَ الميلاد، حيثُ تمَّ استخدامُهُ لوضعِ مجموعةٍ من المبادِئِ التَّوجيهيَّةِ لكيفيَّةِ تَفاعُلِ النَّاس مع بعضِهم البعض في المجتمع، واليوم، يتمُّ استخدامُ (الإتيكيت) بشكلٍ شائعٍ لوصفِ قواعدِ السُّلوكِ أو القواعدِ الَّتي يتَّبِعُها المجتمعُ المؤدَّبُ لتحقيقِ الازدهار والتَّفوُّق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وفقًا لمجلَّة (إيميلي بوست)، تنقسمُ الآداب إلى فئتين هما: الأخلاقُ والمبادئُ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المبادئ هي معاييرُ أخلاقيَّةٌ، مثلُ الاحترامِ، والتَّقديرِ، والصِّدقِ، بينما تُعدُّ الأخلاقُ مهاراتٍ قابلةً للتَّعليم، تختلفُ هذه القِيَمُ والعاداتُ من ثقافةٍ إلى أخرى، ومن بلدٍ إلى آخرَ.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-258a58b9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 78
// module chunks = 0